<template lang="html">
  <div class="full-page">
    <i-header :title="$route.query.title" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body style="background:#fff;padding:17px;">
      <div class="item-box">
        <div class="item-box-title">
          投资者特定对象确认，第一步需要投资者做身份认证。
          投资者需要填写真实的四要输包括姓名、身份证号码、银行卡号、
          银行预留手机号码、短信验证码（机构填写经办人姓名、经办人身份证号、
          对公银行账户、银行预留手机号码、短信验证码）
        </div>
        <div class="item-box-slide">
          <cube-slide :showDots="false">
            <cube-slide-item>
              <img src="~@/assets/confirm2.png" width="100%">
            </cube-slide-item>
          </cube-slide>
          <div class="item-box-slide-desc">
            <div class="item-box-slide-desc-n">
              <span>01</span>/01
            </div>
            <div class="item-box-slide-desc-text">四要素认证</div>
          </div>
        </div>
      </div>

      <div class="item-box">
        <div class="item-box-title">
          若四要素没通过，需要进行人脸识别，相关信息发送到基金管理人后台审核
        </div>
        <div class="item-box-slide">
          <cube-slide :showDots="false">
            <cube-slide-item>
              <img src="~@/assets/confirm1.png" width="100%">
            </cube-slide-item>
          </cube-slide>
          <div class="item-box-slide-desc">
            <div class="item-box-slide-desc-n">
              <span>01</span>/01
            </div>
            <div class="item-box-slide-desc-text">人脸识别</div>
          </div>
        </div>
      </div>


    </i-body>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slideIndex: 0,
    };
  },
  methods: {
    slideChange(index) {
      this.slideIndex = index;
    },
    $_jumpSlideItem(index) {
      this.slideIndex = index === 0 ? 1 : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.item-box {
  margin-bottom: 20px;
  .item-box-title {
    font-size: 13px;
    color: #666666;
  }
  .item-box-slide {
    margin: 10px 0;
    border: 1px solid #eee;
    .item-box-slide-desc {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      padding: 10px 0;
      color: #999;
      .item-box-slide-desc-n > span {
        color: #2E6BE6;
      }
      .item-box-slide-desc-text {
        flex: .6;
      }
    }
  }
}
</style>
